import React, { Component } from 'react'

export class FormSubmitted extends Component {
    componentDidMount() {
    // Scroll to the top of the page
    window.scrollTo(0,0);
    }
    
    render() {
        return (
            <div className="FormSubmitted">
                <h1 className="Page__headline">Thanks!</h1>
                <p className="Page__subheadline">Thanks for reaching out, one of us will be in touch right away!</p>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/FormSubmitted.js